module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_SOUTH_STYLE.3cf6e3bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_SOUTH_STYLE.png
// module id = 1311
// module chunks = 16